import { http } from "services/http";

import type {
  OperationAddRequest,
  OperationsListRequest,
  OperationsListResponse,
  OperationUpdateRequest,
} from "models/operations.model";
import type { UserSelectOption, UsersSelectRequest } from "models/users.model";

export const operationsApi = {
  getOperationsData: (data?: OperationsListRequest) =>
    http.quiet().post<OperationsListResponse>("/api/history", data ? { ...data } : null),
  getUsersOpt: (data: UsersSelectRequest) =>
    http.quiet().post<UserSelectOption[]>("/api/get-users", { ...data }),
  addOperation: (data: OperationAddRequest) => http.quiet().post("/api/history/add", { ...data }),
  updateOperation: (data: OperationUpdateRequest) =>
    http.quiet().post("/api/history/update", { ...data }),
};
